import { X } from "lucide-react";

interface Vehicle {
  model: string;
  licensePlate: string;
}

interface Props {
  vehicle: Vehicle | null;
  deleting: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export default function DeleteFleetModal({
  vehicle,
  deleting,
  onClose,
  onConfirm,
}: Props) {
  if (!vehicle) return null;

  return (
    <div className="fixed inset-0 bg-black/40 z-[100] flex items-center justify-center px-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-6 animate-in fade-in zoom-in duration-200">
        
        {/* Header */}
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-semibold text-gray-800">
            Delete Vehicle
          </h2>

          <button
            onClick={onClose}
            className="p-1 hover:bg-gray-100 rounded-lg"
          >
            <X size={18} />
          </button>
        </div>

        {/* Body */}
        <p className="text-sm text-gray-600 mb-2">
          Are you sure you want to delete:
        </p>

        <div className="bg-gray-50 rounded-xl p-3 mb-5">
          <p className="font-medium text-gray-800">
            {vehicle.model}
          </p>
          <p className="text-sm text-gray-500">
            {vehicle.licensePlate}
          </p>
        </div>

        <p className="text-sm text-red-500 mb-6">
          This action cannot be undone.
        </p>

        {/* Footer */}
        <div className="flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-xl border border-gray-300 text-sm hover:bg-gray-50"
          >
            Cancel
          </button>

          <button
            onClick={onConfirm}
            disabled={deleting}
            className="px-4 py-2 rounded-xl bg-red-600 text-white text-sm hover:bg-red-700 disabled:opacity-50"
          >
            {deleting ? "Deleting..." : "Delete Vehicle"}
          </button>
        </div>
      </div>
    </div>
  );
}